module.exports = __webpack_public_path__ + "static/media/nature.667de607.png";